import richText from "utilities/richText"
import LinedCircle from "/public/assets/decorative-patterns/lined-circle.svg"
import PlusPattern from "/public/assets/decorative-patterns/plus-pattern.svg"

export default function PageHeaderBasic({ heading, subheading }) {
  return (
    <header className="bg-dark-blue-to-blue-inverted text-white py-16 overflow-hidden">
      <div className="container relative flex flex-col lg:flex-row justify-between max-w-screen-xl 2xl:max-w-screen-2xl m-auto gap-4 ">
        <div className="z-10 relative">
          <div className="justify-center items-start prose 2xl:max-w-[80ch] mx-auto lg:mx-0">
            <h1 className="text-white text-l2 md:text-xl1 lg:text-xl2 font-semibold mb-3">{heading}</h1>
            <div className="text-white prose prose-p:text-m2 xl:prose-p:text-m3 2xl:prose-p:text-l1">
              {richText(subheading)}
            </div>
          </div>
        </div>
        <div className="absolute top-20 md:top-6 -left-24 size-72">
          <LinedCircle className="opacity-70 size-72 z-0 fill-blue" />
        </div>
        <div className="absolute z-0 -bottom-24 -right-24 size-72 overflow-hidden">
          <PlusPattern className="opacity-50 size-72 fill-blue-dark" />
        </div>
      </div>
    </header>
  )
}
